var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7659 10.8224H12.9793L17.0015 2.77858C17.1801 2.42083 16.9203 2 16.5202 2H10.996C10.6017 2 10.2536 2.25717 10.1376 2.63389L7.02508 12.7501C6.91479 13.1074 7.18211 13.4691 7.55574 13.4691H11.0384L8.50636 21.7344C8.42916 21.9369 8.69119 22.0953 8.83455 21.9329L17.1259 11.6204C17.3998 11.3107 17.1797 10.8224 16.7659 10.8224Z",
    fill: "url(#paint0_linear_8857_134)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5321 10.5988L12.1703 11.3224H12.9793H16.7239L9.44586 20.3746L11.5165 13.6156L11.7145 12.9691H11.0384H7.55574C7.51836 12.9691 7.49192 12.933 7.50284 12.8976L7.50297 12.8972L10.6155 2.78105C10.6669 2.61397 10.8212 2.5 10.996 2.5H16.5202C16.5307 2.5 16.5358 2.50231 16.5389 2.5041C16.5431 2.50655 16.5482 2.51105 16.5525 2.51795C16.5568 2.52486 16.5585 2.53152 16.5588 2.5365C16.5591 2.54018 16.5588 2.54581 16.5541 2.55519L12.5321 10.5988Z",
    stroke: "#FF4848",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8857_134",
    x1: 12.1236,
    y1: 2.93606,
    x2: 12.1236,
    y2: 19.5743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AA00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.918ed220d910dd7c8b1f6a4ba20ac8b1.svg";
export { ForwardRef as ReactComponent };